'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function GoldSessionModel({config, webSocketShim, authenticationModel, colors}) {
	if (!config || typeof config.websocketUrl !== 'string' || !webSocketShim || !authenticationModel) {
		throw new Error('invalid-args');
	}

	let localSessionId;
	const self = observable(this),
		sessions = {},
		calcSessionColor = session => {
			const sessionId = session.sessionId,
				numericSession = Array.from(sessionId).reduce((a, c) => a + c.charCodeAt(0), 0),
				colorIndex = numericSession % colors.length;
			return colors[colorIndex];
		},
		normalise = function (session) {
			const defaults = {
					description: session.userId,
					color: calcSessionColor(session)
				},
				clone = Object.assign(defaults, session);
			if (clone.type) {
				delete clone.type;
			}
			return clone;
		},
		sessionJoined = session => {
			if (sessions[session.sessionId]) {
				return;
			}
			if (session.sessionId === localSessionId) {
				return;
			}
			sessions[session.sessionId] = normalise(session);
			self.dispatchEvent('sessionAdded', sessions[session.sessionId]);
		},
		sessionLeft = session => {
			if (!sessions[session.sessionId]) {
				return;
			}
			if (session.sessionId === localSessionId) {
				return;
			}
			self.dispatchEvent('sessionRemoved', sessions[session.sessionId]);
			delete sessions[session.sessionId];
		},
		sessionList = message => {
			Object.values(sessions).forEach(sessionLeft);
			message.sessions.forEach(sessionJoined);
		},
		processors = {
			'session:joined': sessionJoined,
			'session:list': sessionList,
			'session:left': sessionLeft
		};


	self.getSessions = () => sessions;

	self.getSession = (sessionId) => sessions[sessionId];

	self.hasRemoteSessions = () => !!Object.keys(sessions).length;
	self.ensureConnection = async ({fileId, sessionId, clientSecret}) => {
		if (localSessionId === sessionId && webSocketShim.isOpen()) {
			return;
		}
		const userId = await authenticationModel.getUserId();
		try {
			await webSocketShim.start(
				config.websocketUrl,
				{fileId, userId, sessionId, clientSecret}
			);
			localSessionId = sessionId;
		} catch (e) {
			self.dispatchEvent('sessionError', e);
		}
	};

	webSocketShim.addEventListener('error', e => self.dispatchEvent('sessionError', e));
	webSocketShim.addEventListener('message', (m) => {
		if (!m || !m.type) {
			//throw new Error('invalid-args');
			console.error(m); //eslint-disable-line no-undef
			self.dispatchEvent('sessionError', m);
		}
		const processor = processors[m.type];
		if (processor) {
			return processor(m);
		}
	});
};

